<template>
	<div @click="showMenu = !showMenu" ref="container_elem" class="menu-item-picker" :class="{ 'is-active': editor.isActive('link') }">
		<LinkSvg />
		<FormattingDialog
			v-if="showMenu"
			title="Link Formatter"
			:content="String(attrs.href || '')"
			:insertedDataSource="attrs.plySource"
			:dontShowInsertData="dontShowInsertData"
			:boundingClientRect="$refs.container_elem?.getBoundingClientRect()"
			@cancel="(v) => (showMenu = v)"
			@saveContent="saveContent"
		/>
	</div>
</template>

<script>
import LinkSvg from './assets/LinkSvg.vue';
import FormattingDialog from './FormattingDialog';

export default {
	name: 'LinkFormatting',
	props: {
		editor: { type: Object },
		selectionObj: { type: Object },
		dontShowInsertData: { type: Boolean },
	},
	components: {
		FormattingDialog,
		LinkSvg,
	},
	computed: {
		attrs: {
			get() {
				return this.editor.getAttributes('link') || '';
			},
		},
	},

	methods: {
		saveContent({ content, plySource }) {
			this.showMenu = false;
			if (content === '') {
				return this.editor.chain().focus().extendMarkRange('link').unsetLink().run();
			}
			const attrsObj = { href: content, plySource, target: '_blank' };
			this.editor.chain().focus().extendMarkRange('link').setLink(attrsObj).run();
		},
	},
	data() {
		return {
			showMenu: false,
		};
	},
};
</script>

<style lang="scss" scoped></style>
